import { ActionReducerMap } from '@ngrx/store';
import { CustomHubState } from './state';
import { hubReducer } from './hub';
import { lastDealsProductsReducer } from './last-deals-products/last-deals-products.reducer';
import { bestSellingProductsReducer } from './best-selling-products/best-selling-products.reducer';

export const customHubReducers: ActionReducerMap<CustomHubState> = {
  hubState: hubReducer,
  lastDealsProductsState: lastDealsProductsReducer,
  bestSellingProductsState: bestSellingProductsReducer
};
